import { ClientStatus } from "../../Enums/ClientStatus.enum";

/**
 * Whether Sales Pipeline Value and Deal Stage are this client's own figures (bug 5716).
 *
 * A prospect has no sales deals, so there is nothing to derive these two from and the relationship
 * manager records them by hand on Details. Once the client is promoted, its real deals exist and are
 * authoritative: both values go back to being derived and the page goes back to read-only, because
 * two editable numbers both called the pipeline value is worse than one that cannot be typed.
 *
 * Dormant counts as promoted. A dormant client was a current client and still has its deals — the
 * figures do not become hand-entered again just because it went quiet.
 *
 * Read from the status the form currently holds rather than the one the record was loaded with, so
 * changing Status on this page flips the controls immediately. The server applies the same test to
 * the status it is about to store, so the screen and the API always agree about whether a save will
 * be kept.
 */
export const areDealFiguresSelfReported = (
  clientStatusID: number | string | null | undefined,
): boolean => {
  const status = Number(clientStatusID);
  return status === ClientStatus.Prospect || status === ClientStatus.Onboarding;
};
